import { MobileNavbar } from 'components/MobileNavbar';
import { PageWrapper } from 'components/PageWrapper';
import { NewMenu } from 'components/Menu/NewMenu';
import React, { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { getLocalAuthStorage } from 'utils/localStorage';
import { MainContentWrapper } from './styled';

const Index = () => {
  const { isAuthenticated, token } = getLocalAuthStorage();
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const queryString = useLocation().search;
  let searchToken = new URLSearchParams(queryString).get('token');
  const navigate = useNavigate();
  if (isAuthenticated && token) {
    if (import.meta.env.DEV) {
      return (
        <PageWrapper>
          <div style={{ marginRight: 30 }}>
            <MobileNavbar />
            {/* <Menu /> */}
            <NewMenu setIsSubMenuOpen={setIsSubMenuOpen} />
          </div>
          <MainContentWrapper isSubMenuOpen={isSubMenuOpen} style={{ paddingTop: 30 }}>
            <h1>ENV: {import.meta.env.MODE}</h1>
            <div style={{ display: 'flex', width: '100%', justifyContent: 'space-evenly' }}>
              <div style={{ width: '48%', background: 'red' }}>teste</div>
              <div style={{ width: '48%', background: 'blue' }}>teste</div>
            </div>
          </MainContentWrapper>
        </PageWrapper>
      );
    }

    // redirect only in production and homolog
    if (searchToken === undefined || searchToken === null || searchToken === '') {
      searchToken = token;
    }
    //window.location.href = `${import.meta.env.VITE_LEGADO}/Security/SignIn.aspx?${searchToken}`;
    navigate('/dashboard');
    return null;
  }

  return <Navigate to="/login" replace />;
};

export { Index };
